export default {
  'EventsCard.view': { en: 'View', fr: 'Voir' },
  'EventsCard.date': { en: 'Date', fr: 'Date' },
  'EventsCard.proposals': { en: 'Proposals', fr: 'Propositions' },
  'EventsCard.status': { en: 'Status', fr: 'Status' },
};
